const React = require('react');
const ReactRedux = require('react-redux');
const ReactRouter = require('react-router');
const Pagination = require('react-bootstrap/lib/Pagination');
const BuildStatus = require('../components/BuildStatus.jsx');
const LoadingBar = require('../components/LoadingBar.jsx');
const DeployStatus = require('../components/DeployStatus.jsx');

const _ = require('underscore');
const actions = require('../_actions.js');
const deployStates = require('../constants/deployment.js');

const moment = require('moment-timezone');

const DeployHistory = function(props) {
	let errorRow = null;
	let pagination = null;

	if (props.error) {
		errorRow = (
			<tr className="danger">
				<td colSpan="5">
					{props.error}
				</td>
			</tr>
		);
	}

	if (props.total_pages > 1) {
		pagination = (
			<div className="text-center">
				<nav>
					<Pagination
						first
						last
						maxButtons={6}
						items={props.total_pages}
						activePage={props.current_page}
						onSelect={props.onPageClick}
					/>
				</nav>
			</div>
		);
	}

	let rows = Object.keys(props.list).map(function(i) {
		const row = props.list[i];
		const state = row.is_current_build ? 'Current' : row.state;

		const date_started = moment.unix(row.date_started_unix)
				.tz(props.user.timezone);

		let rowClasses = 'secondary-content';
		if (row.is_full_deployment) {
			rowClasses += ' full-deployment';
		}
		return (
			<tr className={'fade-in status-' + state} onClick={() => props.onItemClick(row.id)} key={i}>
				<td className="table-cell--multi-line">{date_started.format('DD/MM/YYYY')} <span className={rowClasses}>{date_started.format('h:mma')}</span></td>
				<td className="table-cell--multi-line"><BuildStatus deployment={row} commitAsLink={false} /></td>
				<td>{row.approver ? row.approver.name : <span className="bypassed">Bypassed</span>}</td>
				<td>{row.deployer ? row.deployer.name : null}</td>
				<td className="deploy-status">
					<DeployStatus locked={row.locked_by} state={row.state} />
				</td>
			</tr>
		);
	});
	if (rows.length === 0 && props.is_loading === false) {
		rows = (
			<tr>
				<td colSpan="5" className="text-center">
					There are currently no deployments to show. Start a <ReactRouter.Link to="/deployment/new">new deployment</ReactRouter.Link>?
				</td>
			</tr>
		);
	}

	return (
		<div className="fade-in">
			<h4>History</h4>
			<div className="table-responsive">
				<table className="table table-fullwidth table-clickable table-centered-columns table-hover table-deployments">
					<thead>
						<tr>
							<th>Deploy date</th>
							<th>Build details</th>
							<th>Approval</th>
							<th>Deployed by</th>
							<th>Status</th>
						</tr>
					</thead>
					<tbody>
						{errorRow}
						{rows}
					</tbody>
				</table>
			</div>
			<div className="loading-bar-wrapper">
				<LoadingBar show={props.is_loading} />
				{pagination}
			</div>
		</div>
	);
};

const mapStateToProps = function(state) {

	// try to find the current build in the list of all deployments
	let historyList = {};
	let numDeployments = 0;
	if (typeof state.deployment.list === "object") {
		historyList = _.filter(state.deployment.list, function(deploy) {
			switch (deploy.state) {
				case deployStates.STATE_COMPLETED:
				case deployStates.STATE_INVALID:
				case deployStates.STATE_REJECTED:
				case deployStates.STATE_FAILED:
					numDeployments += 1;
					return true;
				default:
					return false;
			}
		});
	}
	historyList.sort(function(a, b) {
		return b.date_started_unix - a.date_started_unix;
	});

	const perPage = 10;
	// only show paginated result, recalc
	const start = (state.deployment.current_page - 1) * perPage;
	const end = start + perPage;
	const totalPages = Math.ceil(numDeployments / perPage);

	const paginatedList = {};
	let pos = 0;
	Object.keys(historyList).forEach(function(key) {
		if (pos >= start && pos < end) {
			paginatedList[key] = historyList[key];
		}
		pos++;
	});

	return {
		list: paginatedList,
		page_length: perPage,
		total_pages: totalPages,
		current_page: state.deployment.current_page,
		error: state.deployment.history_error,
		is_loading: state.deployment.history_is_loading,
		user: state.user
	};
};

const mapDispatchToProps = function(dispatch) {
	return {
		onItemClick: function(id) {
			actions.history.push('/deployment/' + id.toString());
		},
		onPageClick: function(page) {
			dispatch(actions.setDeployHistoryPage(page));
		}
	};
};

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(DeployHistory);
